import { Form, Input, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons'
import { InvoiceSummaryWithCustomerJobData } from '../../../domain/invoicing/invoice'
import { useCustomerEmailsQuery } from '../../../domain/customers/customerQueries'
import { useInvoiceDetailsQuery, useEmailInvoiceMutation, useSendInvoiceMutation } from '../../../domain/invoicing/invoicingQueries'
import * as emailCustomerInvoice from './emailCustomerInvoiceModel'

type Props = {
  isOpen: boolean
  onClose: () => void
  invoiceSummary: InvoiceSummaryWithCustomerJobData | null
}

const EmailCustomerInvoiceModal = ({ isOpen, onClose, invoiceSummary }: Props) => {
  const [email, setEmail] = useState('')

  const customerEmailsQuery = useCustomerEmailsQuery(isOpen ? invoiceSummary?.customerId ?? 0 : 0)
  const detailsQuery = useInvoiceDetailsQuery(isOpen ? invoiceSummary?.invoiceId ?? '' : '')
  const sendInvoiceMutation = useSendInvoiceMutation()
  const emailInvoiceMutation = useEmailInvoiceMutation()

  const isSynkedUP = invoiceSummary?.invoicingSystem === 'synkedUp'
  const invoice = detailsQuery.data?.invoice

  useEffect(() => {
    if (!isOpen) {
      return
    }
    setEmail(emailCustomerInvoice.pickInitialEmail(invoiceSummary, detailsQuery.data, customerEmailsQuery.data))
  }, [isOpen, customerEmailsQuery.data, detailsQuery.data, invoiceSummary])

  const handleSubmit = () => {
    if (!invoiceSummary) {
      return
    }
    if (isSynkedUP) {
      if (!invoice) {
        return
      }
      sendInvoiceMutation.mutate(
        emailCustomerInvoice.buildSendInvoiceRequest(invoiceSummary, invoice, email),
        { onSuccess: onClose }
      )
    } else {
      emailInvoiceMutation.mutate(invoiceSummary.invoiceId, { onSuccess: onClose })
    }
  }

  const isLoading = sendInvoiceMutation.isLoading || emailInvoiceMutation.isLoading
  const okDisabled = emailCustomerInvoice.isEmailInvoiceSubmitDisabled({ isLoading, email, isSynkedUP, invoice })

  return <Modal
    open={isOpen}
    title="Email Customer Invoice"
    okText="Email Invoice"
    okButtonProps={{ loading: isLoading, disabled: okDisabled }}
    onOk={handleSubmit}
    onCancel={onClose}
  >
    <Form layout="vertical">
      <Form.Item label="Customer Email Address">
        <Input
          prefix={<FontAwesomeIcon icon={faEnvelope} />}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Form.Item>
    </Form>
  </Modal>
}

export default EmailCustomerInvoiceModal
